"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _ResultDialog = require("./ResultDialog");
Object.keys(_ResultDialog).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ResultDialog[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _ResultDialog[key];
    }
  });
});
